import React from 'react';
import { Box, useTheme } from '@mui/material';

const MonthHeader = ({ group, dayWidth, isLast, stickyLeft = 0 }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: `${group.days * dayWidth}px`,
        minWidth: `${group.days * dayWidth}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 600,
        fontSize: '15px',
        borderRight: !isLast ? `2px solid ${theme.palette.grey[600]}` : 'none'
      }}
    >
      {/* Sticky so a month that started off-screen keeps its name readable next
          to the sidebar instead of being centred (and clipped) under it */}
      <Box component="span" sx={{ position: 'sticky', left: stickyLeft + 12, right: 12, px: 1.5, whiteSpace: 'nowrap' }}>
        {group.month}
      </Box>
    </Box>
  );
};

export default MonthHeader;
